import { useEffect, useState } from "react";
import { generateDesignData } from "../../../store/slices/viewSlice";
import { useAppDispatch } from "../../../../hooks/reduxHooks";
import { toast } from "react-toastify";

const ShareDesign = ({
  show,
  setSaveSharePopup,
  isDesignSaved,
  onSaveRequired,
}: any) => {
  const [previewList, setPreviewList] = useState([]);
  const dispatch = useAppDispatch();
  const [redirecting, setRedirecting] = useState(false);
  const [countdown, setCountdown] = useState(2); // Countdown timer (2 seconds)

  // Use current URL instead of passed-in shareURL
  const shareURL = window.location.href;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareURL);
    toast.success("Link copied to clipboard!"); // Success message
  };

  const emailShare = `mailto:?subject=Check out this design&body=${encodeURIComponent(
    shareURL
  )}`;
  const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    shareURL
  )}`;
  const twitterShare = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    shareURL
  )}&text=Check out this design!`;

  useEffect(() => {
    if (show) {
      // Check if design is saved before proceeding
      if (!isDesignSaved) {
        // If not saved, trigger the save popup and close this one
        onSaveRequired && onSaveRequired();
        setSaveSharePopup(false);
        return;
      }

      generateImages();
    }
  }, [show, isDesignSaved]);

  useEffect(() => {
    if (redirecting) {
      const interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            window.location.href = shareURL; // Redirect to shareURL
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [redirecting, shareURL]);

  useEffect(() => {
    if (show && isDesignSaved) {
      setRedirecting(true);
    }
  }, [show, isDesignSaved]);

  const generateImages = () => {
    dispatch(generateDesignData({}))
      .unwrap()
      .then((data: any) => {
        console.log(data);
        const newData: any = [];
        for (const key in data) {
          if (Object.prototype.hasOwnProperty.call(data, key)) {
            const element = data[key];
            newData.push(element);
          }
        }
        setPreviewList(newData);
      });
  };

  return (
    <div className="flex px-5 gap-6 items-center">
      {/* <div className="w-1/3 max-lg:hidden">
        {previewList.map((data: any) => {
          return (
            <>
              <img src={data.image_url} alt="" />
            </>
          );
        })}
      </div> */}
      {/* <div className="lg:w-2/3"> */}
      <div>
        <div className="text-2xl font-bold mb-2">Share your Design</div>
        <div className="text-grey mb-5">
          Your design Design_Name has been saved and emailed to you. Copy your
          design link below and share with others.
        </div>
        <div className="flex gap-3 my-4">
          <input
            className="border border-solid border-[#939393] block mx-auto w-full max-w-[440px] p-2 rounded-md mb-3"
            type="text"
            value={shareURL}
            disabled
          />
          <button
            className="bg-primaryred text-white px-3 uppercase font-bold max-h-[40px] rounded-md"
            onClick={handleCopy}
          >
            Copy
          </button>
        </div>
        <div className="flex justify-center items-end gap-12 w-full my-6 text-xs text-center uppercase">
          <a href={emailShare} target="_blank" rel="noopener noreferrer">
            <svg
              className="mb-2"
              width="33"
              height="25"
              viewBox="0 0 33 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M31.9586 3.35888C31.8267 2.6921 31.5292 2.0619 31.0951 1.53209C31.007 1.42086 30.9148 1.3219 30.814 1.22152C30.0418 0.445242 28.9676 0 27.8669 0H4.46021C3.3472 0 2.30041 0.43402 1.51266 1.22195C1.41296 1.3214 1.32051 1.42135 1.229 1.53612C0.796837 2.0637 0.500649 2.69303 0.371869 3.36074C0.318051 3.62295 0.290894 3.89465 0.290894 4.1695V20.6088C0.290894 21.1807 0.407087 21.7376 0.637427 22.267C0.836767 22.7372 1.13922 23.1829 1.51241 23.5559C1.60641 23.6495 1.69978 23.7358 1.79948 23.8199C2.54563 24.4379 3.49043 24.7779 4.46021 24.7779H27.8669C28.843 24.7779 29.7868 24.4366 30.531 23.8131C30.6304 23.7326 30.7226 23.6481 30.8148 23.5559C31.1756 23.1956 31.4623 22.7815 31.6684 22.3249L31.6955 22.2598C31.9216 21.7404 32.0363 21.1853 32.0363 20.6088V4.1695C32.0363 3.89824 32.0102 3.62475 31.9586 3.35888ZM2.45002 2.66091C2.50898 2.57461 2.58425 2.486 2.6803 2.38922C3.15704 1.91273 3.78928 1.65052 4.46015 1.65052H27.8668C28.5436 1.65052 29.176 1.91316 29.6475 2.39015C29.7289 2.47243 29.8067 2.56376 29.8745 2.65502L30.0535 2.89559L17.5599 13.7843C17.1748 14.122 16.6789 14.3078 16.1634 14.3078C15.6531 14.3078 15.1576 14.1224 14.7679 13.7847L2.28676 2.89869L2.45002 2.66091ZM1.94978 20.7539C1.94302 20.7091 1.94147 20.6594 1.94147 20.6088V4.5099L11.6369 12.9678L2.03931 21.3357L1.94978 20.7539ZM29.116 22.7955C28.7407 23.012 28.3086 23.1268 27.8669 23.1268H4.46021C4.01832 23.1268 3.58634 23.012 3.21135 22.7955L2.819 22.568L12.7355 13.9261L13.8223 14.8714C14.4742 15.4374 15.3055 15.7494 16.1636 15.7494C17.0248 15.7494 17.8575 15.4374 18.5089 14.8714L19.5953 13.9257L29.5084 22.5685L29.116 22.7955ZM30.3853 20.6088C30.3853 20.6585 30.3844 20.7078 30.3781 20.7516L30.2922 21.3389L20.6906 12.9723L30.3853 4.51399V20.6088Z"
                fill="#212B35"
              />
            </svg>
            Email
          </a>
          <a href={facebookShare} target="_blank" rel="noopener noreferrer">
            <svg
              className="mb-1"
              width="33"
              height="33"
              viewBox="0 0 33 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32.828 16.2911C32.7906 13.2477 31.8843 10.2783 30.2157 7.73261C28.5472 5.18696 26.1861 3.17109 23.4103 1.92243C20.6344 0.67376 17.5596 0.244302 14.5478 0.6846C11.5362 1.12492 8.71301 2.41665 6.41086 4.40772C4.10869 6.39878 2.42342 9.00623 1.5535 11.923C0.683604 14.8398 0.665277 17.9443 1.50072 20.8712C2.33616 23.7981 3.99054 26.4251 6.26906 28.4432C8.54755 30.4613 11.3553 31.7863 14.3616 32.2621V20.9427H10.3689V16.2911H14.3616V12.7576C14.2692 11.936 14.3582 11.1041 14.6225 10.3206C14.8868 9.53716 15.3198 8.82127 15.891 8.22346C16.4622 7.62562 17.1575 7.16045 17.9281 6.86078C18.6987 6.56108 19.5258 6.43417 20.3507 6.48903C21.5481 6.50542 22.7427 6.61221 23.9242 6.80845V10.8012H21.9278C21.5836 10.7578 21.2339 10.7923 20.9049 10.9021C20.5757 11.012 20.2754 11.1944 20.0263 11.4359C19.7771 11.6774 19.5855 11.9717 19.4655 12.2972C19.3453 12.6228 19.3 12.9712 19.3325 13.3165V16.3311H23.7645L23.0458 20.9826H19.3525V32.1622C23.1254 31.5655 26.5596 29.6362 29.0319 26.7243C31.5042 23.8124 32.8509 20.111 32.828 16.2911Z"
                fill="#212B35"
              />
            </svg>
            Share
          </a>

          <a href={twitterShare} target="_blank" rel="noopener noreferrer">
            <svg
              className="mb-1"
              width="32"
              height="27"
              viewBox="0 0 32 27"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M28.5507 6.92821C28.5633 7.20728 28.5696 7.48766 28.5696 7.76928C28.5696 16.3593 22.0308 26.2638 10.0758 26.2638C6.40468 26.2638 2.98752 25.1876 0.110962 23.3432C0.620129 23.4035 1.13686 23.4344 1.66178 23.4344C4.70742 23.4344 7.50976 22.3952 9.7351 20.6514C6.88998 20.5993 4.48991 18.7198 3.66267 16.1374C4.05998 16.2134 4.46672 16.2543 4.88599 16.2543C5.47811 16.2543 6.05263 16.1745 6.59832 16.0261C3.62497 15.4289 1.38388 12.8019 1.38388 9.65255C1.38388 9.6249 1.38388 9.59786 1.38456 9.57083C2.26085 10.0574 3.26288 10.3497 4.32895 10.3836C2.58457 9.21822 1.43733 7.22861 1.43733 4.97313C1.43733 3.78193 1.75726 2.66551 2.31733 1.70558C5.52331 5.63818 10.312 8.22555 15.7144 8.49713C15.6038 8.02125 15.5459 7.52529 15.5459 7.01551C15.5459 3.4261 18.4564 0.515625 22.0458 0.515625C23.9166 0.515625 25.605 1.30517 26.7905 2.56804C28.2716 2.277 29.6621 1.73578 30.918 0.990815C30.4327 2.50895 29.403 3.78249 28.0604 4.5871C29.3754 4.42993 30.6289 4.08048 31.7943 3.56375C30.9231 4.86692 29.8206 6.01162 28.5507 6.92821Z"
                fill="#212B35"
              />
            </svg>
            Tweet
          </a>
        </div>
        <button
          onClick={() => setSaveSharePopup(false)}
          className="w-full text-center block bg-primaryred text-white font-bold text-xl py-2 px-7 rounded-full mx-auto mt-4"
        >
          Close
        </button>
        {redirecting && (
          <div className="text-center mt-5">
            Redirecting to the shared link in {countdown} seconds...
          </div>
        )}
      </div>
    </div>
  );
};
export default ShareDesign;
